import {useEffect, useState} from 'react';
import apiFetch from '@wordpress/api-fetch';

// api fetch
const zbcf_searchlist = [];
let contactArr        = [];

apiFetch({path: 'https://www.utp-umwelttechnik-poehnl.de/wp-json/wp/v2/zbcf?per_page=100'}).then((zbcf_contacts) => {
	for (const zbcf_contact of zbcf_contacts) {
		zbcf_searchlist.push({
			id: zbcf_contact.id,
			zips: zbcf_contact.zip_codes,
			country: zbcf_contact.area,
			name: zbcf_contact.title.rendered,
			thumb: zbcf_contact.featured_media,
			content: zbcf_contact.content.rendered
		},);
	}
});

function App() {

	const [country, setCountry]           = useState('Deutschland');
	const [zip, setZIP]                   = useState('');
	const [foundEntries, setFoundEntries] = useState(contactArr);


	const filterZIP     = (e) => {
		const inputString = e.target.value;
		setZIP(inputString.trim());
	};
	const filterCountry = (e) => {
		const inputString = e.target.value;
		setCountry(inputString.trim());
	};

	function updateResult() {
		contactArr = [];
		//setFoundEntries(contactArr);


		//console.log(`COUNTRY: ${country} ZIP: ${zip}`);

		function checkIfStringStartsWith(str, arr) {
			return arr.some(substr => substr.startsWith(str));
		}

		zbcf_searchlist.forEach(function (contact) {
			let zipArrContact = contact.zips.split(/[, ]+/);
			if (checkIfStringStartsWith(zip, zipArrContact)) {
				contactArr.push(contact);
			}
		});

		contactArr = contactArr.filter(contact => contact.country.startsWith(country));

		if (contactArr.length === 0) {
			contactArr = zbcf_searchlist.filter(contact => contact.zips === 'fallback');
		}

		if (country && zip.length > 3) {
			setFoundEntries(contactArr);
			//console.dir(contactArr);
		}
		if (country && zip.length <= 3) {
			contactArr = [];
			setFoundEntries(contactArr)
		}
	}


	useEffect(() => {
		updateResult();
	}, [zip])

	useEffect(() => {
		updateResult();
	}, [country])


	return (
		<div>
			<div className="zbcf-inputs">
				<label htmlFor="country-1">
					<input
						id="country-1"
						type="radio"
						defaultChecked={true}
						name="if-zbcf-finder-country"
						value="Deutschland"
						onChange={filterCountry}
						className="input"
					/>
					Deutschland
				</label>

				<label htmlFor="country-2">
					<input
						id="country-2"
						type="radio"
						name="if-zbcf-finder-country"
						value="Österreich"
						onChange={filterCountry}
						className="input"
					/>
					Österreich
				</label>

				<label htmlFor="country-3">
					<input
						id="country-3"
						type="radio"
						name="if-zbcf-finder-country"
						value="Schweiz"
						onChange={filterCountry}
						className="input"
					/>
					Schweiz
				</label>

				<input
					type="search"
					name="if-zbcf-finder"
					value={zip}
					onChange={filterZIP}
					className="input"
					placeholder="PLZ eingeben"
				/>
			</div>


			<div className="user-list">
				{foundEntries && foundEntries.length !== '' ? (
					foundEntries.map((user) => (
						<div key={user.id} className="user">
							<div dangerouslySetInnerHTML={{__html: user.content}}/>
						</div>
					))
				) : (
					<p class="hide"><small>PLZ eingeben</small></p>
				)}
			</div>
		</div>
	);
}

export default App;
